import api from "../utils/api";

class VehiclesApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/vehicles", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getAllFromOperator = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/v1/pos/vehicles", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post("/vehicles", data);

        resolve(res.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/vehicles/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/vehicles/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/vehicles/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const vehiclesApi = new VehiclesApi();
export default vehiclesApi;
